import {evite} from 'evite';
import * as _reactDomClient from 'node-modules-react-dom-client';

evite.set(evite, 'exports.ReactDomClient', _reactDomClient);
